import { Size } from '@busybusy/webapp-react-ui';
import { HeaderDialog } from 'components';
import type { IManageEquipmentRowInfo } from 'containers/manage-euipment/ManageEquipment';
import { ManageEquipmentBulkAddRoutineInspections } from 'containers/manage-euipment/ManageEquipmentGroupActionInspections/ManageEquipmentBulkAddRoutineInspections';
import { ManageEquipmentBulkUpdateOperationInspections } from 'containers/manage-euipment/ManageEquipmentGroupActionInspections/ManageEquipmentBulkUpdateOperationInspections';
import type { IOpenableHook } from 'hooks/utils/useOpenable';
import { t } from 'utils/localize';
import './ManageEquipmentGroupActionInspections.scss';

export const ManageEquipmentGroupActionInspectionsModes = {
  updatePreOperationInspections: {
    key: 'updatePreOperationInspections',
    field: 'preOperationChecklistId',
    title: 'Update Inspections',
    fieldLabel: 'Pre-Operation Inspections',
  },
  updatePostOperationInspections: {
    key: 'updatePostOperationInspections',
    field: 'postOperationChecklistId',
    title: 'Update Inspections',
    fieldLabel: 'Post-Operation Inspections',
  },
  addRoutineInspections: {
    key: 'addRoutineInspections',
    field: 'routineChecklistId',
    title: 'Add Routine Inspections',
    fieldLabel: 'Inspection',
  },
} as const;

export type TManageEquipmentGroupActionInspectionsMode = keyof typeof ManageEquipmentGroupActionInspectionsModes;

export interface IManageEquipmentGroupActionInspectionsProps {
  mode: TManageEquipmentGroupActionInspectionsMode;
  checkedRows: IManageEquipmentRowInfo[];
  openable: IOpenableHook;
  onSubmit: () => void;
}
export default function ManageEquipmentGroupActionInspections({
  openable,
  checkedRows,
  mode,
  onSubmit,
}: IManageEquipmentGroupActionInspectionsProps) {
  const modeInfo = ManageEquipmentGroupActionInspectionsModes[mode];

  return (
    <HeaderDialog
      isOpen={openable.isOpen}
      onClose={openable.close}
      title={t(modeInfo.title)}
      headerSize={Size.XL}
      divider={false}
    >
      <div className="mb-6 p-8">
        {mode === 'updatePreOperationInspections' || mode === 'updatePostOperationInspections' ? (
          <ManageEquipmentBulkUpdateOperationInspections mode={mode} checkedRows={checkedRows} onSubmit={onSubmit} />
        ) : null}
        {mode === 'addRoutineInspections' ? (
          <ManageEquipmentBulkAddRoutineInspections
            checkedRows={checkedRows}
            onClose={openable.close}
            onSubmit={onSubmit}
          />
        ) : null}
      </div>
    </HeaderDialog>
  );
}
